import { Link } from "react-router-dom";
import { MapPin, Calendar, ArrowUpRight } from "lucide-react";
import { formatShortDateFr } from "@/lib/api";

export default function ConcertCard({ concert, large = false }) {
  const onSale = concert.status === "on_sale";
  const datesPreview = concert.dates.slice(0, 3).map(formatShortDateFr).join(" · ");
  const more = concert.dates.length > 3 ? ` +${concert.dates.length - 3}` : "";

  return (
    <Link
      to={`/concert/${concert.slug}`}
      className={`concert-card group relative block bg-card border border-white/10 rounded-sm overflow-hidden ${
        large ? "md:row-span-2 md:col-span-2" : ""
      }`}
      data-testid={`concert-card-${concert.slug}`}
    >
      <div className={`img-wrap relative overflow-hidden ${large ? "aspect-[4/5] md:aspect-[16/13]" : "aspect-[4/5]"}`}>
        <img
          src={concert.image_url}
          alt={concert.artist}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          {onSale ? (
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase bg-primary text-primary-foreground px-2 py-1 rounded-sm pulse-gold">
              En vente
            </span>
          ) : (
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase bg-black/70 border border-white/20 text-white px-2 py-1 rounded-sm">
              Bientôt
            </span>
          )}
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase bg-black/70 border border-white/20 text-white px-2 py-1 rounded-sm">
            {concert.genre}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className={`font-black tracking-tight ${large ? "text-3xl md:text-5xl" : "text-xl md:text-2xl"} leading-none`}>
            {concert.artist}
          </h3>
          <p className="font-mono text-xs text-muted-foreground mt-2 truncate">
            {datesPreview}{more}
          </p>
        </div>
      </div>

      <div className="flex items-center justify-between px-5 py-4 border-t border-white/10">
        <div className="flex items-center gap-3 text-xs font-mono text-muted-foreground min-w-0">
          <span className="flex items-center gap-1.5 truncate">
            <MapPin size={12} /> {concert.venue}
          </span>
          <span className="flex items-center gap-1.5">
            <Calendar size={12} /> {concert.dates.length} date{concert.dates.length > 1 ? "s" : ""}
          </span>
        </div>
        <span className="flex items-center gap-1 text-sm font-bold text-primary group-hover:gap-2 transition-all">
          {onSale ? "Réserver" : "Détails"} <ArrowUpRight size={16} />
        </span>
      </div>
    </Link>
  );
}
